<template>
  <div class="loading">
    <i class="el-icon-loading"></i>
    <div>{{text}}</div>
  </div>
</template>
<script>
export default {
  name: "Loading",
  props: {
    text: {
      type: String,
      default: "Loading..."
    }
  }
};
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $primary-color;
}
</style>